import React, { useState } from "react";

function ForgotPassword({ onBack }) {
  const [step, setStep] = useState(1); // 1=email, 2=OTP verify, 3=reset password
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [verified, setVerified] = useState(false);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const BASE_URL = "https://mondelezbc.vsmglobaltechnologies.com/api/user";

  // 📨 Step 1: Send OTP
  const sendOtp = async (e) => {
    e.preventDefault();
    setMessage(null);
    setLoading(true);

    try {
      const res = await fetch(`${BASE_URL}/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();
      if (res.ok) {
        setMessage(data.message || `OTP sent to ${email}`);
        setStep(2);
      } else {
        setMessage(data.message || "Email not found.");
      }
    } catch (err) {
      setMessage("Server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  // 🔑 Step 2: Verify OTP
  const verifyOtp = async (e) => {
    e.preventDefault();
    setMessage(null);
    setLoading(true);

    try {
      const res = await fetch(`${BASE_URL}/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp }),
      });

      const data = await res.json();
      if (res.ok) {
        setVerified(true);
        setMessage(
          data.message ||
            "OTP verified successfully. You can now reset your password."
        );
      } else {
        setMessage(data.message || "Invalid OTP. Please try again.");
      }
    } catch (err) {
      setMessage("Server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  // 🔐 Step 3: Reset Password
  const resetPassword = async (e) => {
    e.preventDefault();
    setMessage(null);

    if (password !== confirm) {
      setMessage("Passwords do not match.");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(`${BASE_URL}/re-enter-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();
      if (res.ok) {
        setMessage(data.message || "Password reset successful. Redirecting...");
        setTimeout(onBack, 2000);
      } else {
        setMessage(data.message || "Unable to reset password.");
      }
    } catch (err) {
      setMessage("Server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  // 🔁 Optional: Resend OTP
  const resendOtp = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${BASE_URL}/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();
      if (res.ok) {
        setMessage(data.message || "OTP resent successfully.");
      } else {
        setMessage(data.message || "Failed to resend OTP.");
      }
    } catch (err) {
      setMessage("Server error. Try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center vh-100"
      style={{
        background:
          "linear-gradient(to bottom right, #4b0076 0%, #7b1fa2 100%)",
      }}
    >
      <form
        onSubmit={step === 1 ? sendOtp : !verified ? verifyOtp : resetPassword}
        className="bg-white p-4 rounded shadow"
        style={{ width: 340 }}
      >
        <h4 className="mb-3 text-center">
          {step === 1
            ? "Forgot Password"
            : !verified
            ? "Verify OTP"
            : "Reset Password"}
        </h4>

        {message && (
          <div
            className={`alert ${
              message.toLowerCase().includes("invalid") ||
              message.toLowerCase().includes("error")
                ? "alert-danger"
                : "alert-info"
            }`}
          >
            {message}
          </div>
        )}

        {step === 1 && (
          <>
            <input
              type="email"
              required
              placeholder="Your Email"
              className="form-control mb-3"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button
              type="submit"
              className="btn btn-primary w-100 mb-2"
              disabled={loading}
            >
              {loading ? "Sending..." : "Send OTP"}
            </button>
          </>
        )}

        {step === 2 && !verified && (
          <>
            <input
              type="text"
              placeholder="Enter OTP"
              className="form-control mb-3"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              required
            />
            <button
              type="submit"
              className="btn btn-primary w-100 mb-2"
              disabled={loading}
            >
              {loading ? "Verifying..." : "Verify OTP"}
            </button>
            <button
              type="button"
              className="btn btn-link w-100"
              onClick={resendOtp}
              disabled={loading}
            >
              Resend OTP
            </button>
          </>
        )}

        {verified && (
          <>
            <input
              type="password"
              placeholder="New Password"
              className="form-control mb-3"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <input
              type="password"
              placeholder="Confirm Password"
              className="form-control mb-3"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
            />
            <button
              type="submit"
              className="btn btn-primary w-100 mb-2"
              disabled={loading}
            >
              {loading ? "Resetting..." : "Reset Password"}
            </button>
          </>
        )}

        <button
          type="button"
          className="btn btn-secondary w-100 mt-2"
          onClick={onBack}
        >
          Back to Login
        </button>
      </form>
    </div>
  );
}

export default ForgotPassword;
